import { render, staticRenderFns } from "./3dManage.vue?vue&type=template&id=651aa717&scoped=true&"
import script from "./3dManage.vue?vue&type=script&lang=js&"
export * from "./3dManage.vue?vue&type=script&lang=js&"
import style0 from "./3dManage.vue?vue&type=style&index=0&id=651aa717&prod&lang=css&"
import style1 from "./3dManage.vue?vue&type=style&index=1&id=651aa717&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651aa717",
  null
  
)

export default component.exports